// extracted by mini-css-extract-plugin
export default {"page":"withHeader_page__7rySE"};